import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { EngineParamReportService } from './engine-param-report.service';
import { AppCommonService } from '../app.common.service';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { DomSanitizer } from "@angular/platform-browser";
import { SessionStorageService } from "angular-web-storage";
import { OtpDialogService } from "../otp-dialog/otp-dialog.service";
import { MatDialog } from '@angular/material';
import { OtpDialogComponent } from '../otp-dialog/otp-dialog.component';
import { ReportsService } from '../reports/reports.service';
import { formatDate } from "@angular/common";
import { VesseltypeService } from '../vesseltype/vesseltype.service';

@Component({
  selector: 'app-engine-param-report',
  templateUrl: './engine-param-report.component.html',
  styleUrls: ['./engine-param-report.component.scss']
})
export class EngineParamReportComponent implements OnInit {
  @Input() vesselId!: number;
  @Input() voyageNumber!: string;
  engineParams: any[] = [];
  dataAvailable: boolean = true
  masterSignature: any = '';
  roleid: number;
  roleName: string;
  masterName: string;
  shipLoading: boolean = false;
  signdate: any;
  logbookAuthorizedBy: any;
  formIdObject: string = '';
  showVoyageNo; string;
  showMasterName: string;
  vesselData;
  cospData;
  logoBase64: string = this.vts.logoBase64;


  @ViewChild("successbox", { static: true }) successbox: SwalComponent;
  @ViewChild("errorbox", { static: true }) errorbox: SwalComponent;

  constructor(private eprs: EngineParamReportService, private commonService: AppCommonService, private domSanitizer: DomSanitizer, private session: SessionStorageService, private otpService: OtpDialogService, private dialog: MatDialog, private rs: ReportsService, private vts: VesseltypeService) { }

  ngOnInit(): void {

    this.roleid = this.session.get("roleid");
    this.masterName = this.session.get("firstname") + this.session.get("lastname");
    console.log('==masterName==', this.masterName)
    console.log('==roleid==', this.roleid);
    if (!this.vesselId || !this.voyageNumber) {
      this.showErrorMsg('Error', 'Vessel ID or Voyage Number is missing.')
      return;
    }

    this.fetchEngineParameters();
  }

  private fetchEngineParameters(): void {
    this.eprs.getEngineParameters(this.vesselId, this.voyageNumber).subscribe({
      next: ({ responsecode, data }) => {
        console.log('==response-getEngineParameters==', data);

        if (responsecode === 200 && Array.isArray(data)) {
          this.showVoyageNo = data[0].voyageNumber;
          this.showMasterName = data[0].masterName;
          this.getVesselDetailByVesselId(data[0].vesselId);
          this.getCospDetail(data[0].vesselId, data[0].voyageNumber);
          this.engineParams = data.map(({ adjustmentCarreidOut, adjustmentCarreidOutComment, old_adjustment, remarks, old_remark, remarksComment, date, dateComment, old_date, usersign, edited_by, edited_on }) => ({
            adjustmentCarreidOut,
            adjustmentCarreidOutComment,
            old_adjustment,
            remarks,
            old_remark,
            remarksComment,
            date,
            dateComment,
            old_date,
            usersign,
            edited_by,
            edited_on
          }));
        } else if (responsecode === 404) {
          this.dataAvailable = false;
          this.showErrorMsg('Data Not Found', 'No data is available for the specified vessel and voyage.');
        }
      },
      error: (error) => {
        console.error('Error fetching engine parameters:', error);
      }
    });
  }

  downloadPDF(pdfTitle: any) {
    var node = document.getElementById("print-section");
    var newPdfTitle = pdfTitle ? pdfTitle : 'Record_Book_Of_Engine_Parameter';
    const htmlContent = node.innerHTML;
    console.log('==htmlContent==', htmlContent)
    this.commonService.openDialog(htmlContent, newPdfTitle);
  }

  showSuccessMsg(title: string, text: string) {
    this.successbox.title = title;
    this.successbox.text = text;
    this.successbox.show();
  }

  showErrorMsg(title: string, text: string) {
    this.errorbox.title = title;
    this.errorbox.text = text;
    this.errorbox.show();
  }

  async notifyMaster() {
    const isValid = await this.validateMasterByOtp();
    if (isValid == true) {
      console.log("✅ OTP Verified Successfully.");
      this.showSuccessMsg('Verification Successful', 'Your identity has been verified successfully.')
      this.onAuthrorizeSheet();
    } else if (isValid == false) {
      this.showErrorMsg('Invalid OTP', 'The OTP you entered is incorrect. Please try again.')
    } else if (isValid == 'cancel') {
      console.log("OTP dialog was closed manually. No Verification attempted")
    }
  }

  async validateMasterByOtp(): Promise<boolean | 'cancel'> {
    this.setLoading(true);
    try {
      let dialogRef;

      console.log('==otpService.getIsOtpActive==', this.otpService.getIsOtpActive())

      if (this.otpService.getIsOtpActive()) {
        dialogRef = this.dialog.open(OtpDialogComponent, {
          width: '500px',
          disableClose: true,
          data: { type: 'emailOtpActive', vesselId: this.vesselId },
        });
      } else {
        dialogRef = this.dialog.open(OtpDialogComponent, {
          width: '500px',
          disableClose: true,
          data: { type: 'approvalOtpActive', vesselId: this.vesselId },
        });
      }


      const result = await dialogRef.afterClosed().toPromise();
      console.log('==Dialogbox-closed-result==', result);

      if (result == false) {
        this.otpService.clearOtpTimer();
      }

      return result;
    } catch (error) {
      this.showErrorMsg('Error', 'Something went wrong while sending OTP');
      return false;
    } finally {
      this.setLoading(false);
    }
  }

  private setLoading(state: boolean) {
    this.shipLoading = state;
  }

  onAuthrorizeSheet() {
    var date = new Date();
    var currentdate = formatDate(date, "dd-MMM-yyyy h:mm:ss a", "en-US");
    this.masterName =
      this.session.get("firstname") + " " + this.session.get("lastname");
    this.roleid = this.session.get("roleid");
    this.roleName = this.session.get("rolename");
    this.signdate = currentdate; //"01-Sep-2020";

    this.masterSignature = this.session.get("userSignature");

    var formId = 84;

    this.logbookAuthorizedBy = [];

    this.logbookAuthorizedBy = {
      "masterName": this.masterName,
      "masterSignature": this.masterSignature,
      "roleId": this.roleid,
      "roleName": this.roleName,
      "vesselId": this.vesselId,
      "voyageNumber": this.voyageNumber
    }

    console.log("===this.logbookAuthorizedBy==", this.logbookAuthorizedBy);

    this.eprs.updateRankSignatureByVesselAndVoyage(this.logbookAuthorizedBy).subscribe(
      (data) => {
        console.log('Success:', data);
      },
      (error) => {
        console.error('Error:', error);
      }
    );
  }

  getSignature(imagedata: string) {
    return imagedata != "" && imagedata != null
      ? this.domSanitizer.bypassSecurityTrustUrl(
        "data:image/jpg;base64," + imagedata
      )
      : this.domSanitizer.bypassSecurityTrustUrl(
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAABQUlEQVRYhe3WTytEYRTH8Q+NNERZmFIWlhQrspK1LUuy8C5EsmFnyxvwHpQsrZSVWVhYSA01CxulFA2LeYY7/tzM4xoW91en+3See875du7TPQ+5/rGeI+wcQ38JkClEI2EMcCYQsQDlxLP0FwCDOJNBJ2IBZAVxhLkIgM+s/FVQRwxZCkCaWq5VwCYucYUtdLXO1fKnfNWGj63cbifARQicxXRYV9oJcB8Ce36YKDWuMyJhpsoBcoAcoNCGGqkz4DsdKAaL0QAWI2OdqP/B9rDj87Fawi6quMFCYq+I4xC3FgMwjgfU8IRHTCX2V3CreVg1ZkU/DoPvCsMxALDu4yTsxX7Cf4DJsK5hxtu9sIqx2OLUD+lpSNgdfMsh+R2WEu9ea+5GGSM/Kd7QhObWwypG3/nmA0RF/cz0ZVE816/rBQZFh/X/XGGHAAAAAElFTkSuQmCC"
      );
  }

  getVesselDetailByVesselId(vesselid) {

    this.vts.getVesselDataById(vesselid, (vesselData) => {
      console.log("check-vessel-data", vesselData);
      this.vesselData = vesselData.data;
    })
  }

  getCospDetail(vesselId: number, voyageno: string) {
    this.rs.getCOSPByvesselId(vesselId, voyageno, (responseData) => {
      console.log('==responsecode==', responseData)
      this.cospData = responseData.data[0];
      
    })
  }

}
